import styles from "./FooterInfo.module.css";

/**
 * @author yjkim
 * @date 2022-09-05 09:33
 * @remark 하단 Footer 회사 정보
 * @returns FooterInfo JSX.Element
 */

const delimiter = <span className={styles.delimiter}> | </span>;
function FooterInfo() {
    return (
        <div className={styles.footerInfo}>
            {/*<img className={styles.companyName} src={require('./../../img/footer_logo.png')} alt="" />*/}
            <p className={styles.row}>본 웹사이트는 KSIC에서 제공하는 서비스입니다.</p>
            <p className={styles.row}>
                <span>T E L : 02-576-7070</span>
                {delimiter}
                <span>F A X : 02-576-0578</span>
            </p>
            <p className={styles.row}>
                <span>사업자등록번호 : 206-81-14101</span>
                {delimiter}
                <span>대표자명 : 김인현</span>
            </p>
            <p className={styles.row}>
                <span>통신판매업신고번호 : 제2022-서울관악-0192호</span>
            </p>
            <p className={styles.row}>주소 : 서울특별시 관악구 관악로 1, 서울대학교 공과대학 에너지자원신기술연구소 410호</p>
            <div className={styles.copyright}>Copyright 2019 ⓒ Korea Spatial Information & Communication Inc.</div>
        </div>
    );
}

export default FooterInfo;
